module.exports = __webpack_public_path__ + "img/zorn.060db62e.png";